<template>
  <aha-modal
    :title="modalTitle"
    @hide="$emit('hideModal')"
  >
    <div>{{ modalContent }}</div>
    <template #action>
      <aha-button
        @click="switchMode()"
        has-margin-right
        :submitting="isSwitchingPrivateMode"
      >
        {{ modalPrimaryButtonText }}
      </aha-button>
      <aha-link
        class="font-bold"
        @click="$emit('hideModal')"
      >
        {{ $i18nPresenter.t("Cancel") }}
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import EventBus from '@/eventBus'
import PresentationApi from '@/api/presentation'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    openFrom: {
      type: String,
      default: 'Presenting menu',
    },
  },
  data: () => ({
    isSwitchingPrivateMode: false,
  }),
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    modalTitle() {
      return this.presentation.privateMode ? this.$i18nPresenter.t('Switch to public') : this.$i18nPresenter.t('Switch to private')
    },
    modalContent() {
      if (this.presentation.privateMode) {
        return this.$i18nPresenter.t('By doing this, your audience can see your slides and interact from their devices.')
      }
      return this.$i18nPresenter.t('By doing this, your audience cannot see your slides or interact from their devices.')
    },
    modeIconName() {
      return this.presentation.privateMode ? 'unhide' : 'hide'
    },
    modalPrimaryButtonText() {
      const mode = this.presentation.privateMode ? 'public' : 'private'
      return `${this.$i18nPresenter.t(`Switch to ${mode}`)}`
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSlideActiveAction', 'setSyncLoadingAction']),
    switchMode() {
      EventBus.$emit('setLoadingPrivateMode', {
        isSwitchingPrivateMode: true,
      })
      this.isSwitchingPrivateMode = true
      this._updatePresentation()
    },

    async _updatePresentation() {
      try {
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, {
          privateMode: !this.presentation.privateMode,
        })
        this._handleAfterUpdate()
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    _handleAfterUpdate() {
      EventBus.$emit('setLoadingPrivateMode', {
        isSwitchingPrivateMode: false,
      })
      this.isSwitchingPrivateMode = false
      this.$emit('hideModal')
      const mode = this.presentation.privateMode ? 'private mode' : 'public mode'
      utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        `${this.openFrom} > Presenter switch to ${mode}`,
        `Presentation id: ${this.presentation.id}`,
      )
    },
  },
}
</script>
